const wowApp = require('angular').module('wowApp.auth');

// Services

wowApp.service('ResetPasswordService', ['Restangular', require('./reset-password.service')]);

// Directives
wowApp.component('wowResetPassword', require('./reset-password.component').resetPasswordComponentDefinition);



// WEBPACK FOOTER //
// ./src/auth/resetpassword/index.js